module.exports = __webpack_public_path__ + "static/media/rohit_choudhari.b1b7f770.jpeg";